import React from 'react';

import Units from './unitsComponent.jsx';
import SingleUnit from './singleUnitComponent';

import { $changeZIndex } from './../../mixin/mixin-jquery';

var classNames = require('classnames');

class Lightbox extends React.Component {
  constructor(props) {
    super();

    this._handleClose = this._handleClose.bind(this);
    this.handleClickFilter = this.handleClickFilter.bind(this);
    this.createUnit = this.createUnit.bind(this);

    this._$changeZIndex = $changeZIndex;

    this.state = {
      // because there's no "Critical Content" unit items, only 'Fundamental' and 'Advanced'
      tempClassification: props.currClassification === 'Critical Content' ? '' : props.currClassification
    };

    this.lightboxClasses = classNames({
      'lightbox-units': true,
      'no-filters': props.hideFilters == true
    });
  }

  render() {

    return <div className={this.lightboxClasses}>
        <div className="lightbox-units-inner">

          <a href="#" className="lightbox-units-close" onClick={this._handleClose}>&#215;</a>

          <h3 className="heading">
            <span className="prefix">Units from</span>
            {this.props.heading}
          </h3>

          <div className="lightbox-units-body">
            <div className="lightbox-units-body-inner">

              { typeof this.props.data.unit_count === 'undefined' ?
                  <div className="app-placeholder"></div> :
                  <Units data={this.props.data}
                         options={this.props.options}
                         heading={this.props.heading}
                         classification={this.state.tempClassification}
                         comparedUnits={this.props.comparedUnits}
                         handleClickFilter={this.handleClickFilter}
                         createUnit={this.createUnit}
                         lightboxType={this.props.lightboxType} />}
            </div>
          </div>
        </div>
      </div>;
  }

  handleClickFilter(value, e) {
    e.preventDefault();

    this.setState({
      tempClassification: value
    });
  }

  _handleClose(e) {
    e.preventDefault();

    this.props.dispatchReducer([
      {type: 'LBOX::CLOSE'},
      {type: 'UNITS::REMOVE'}
    ]);

    // increase container's z-index to override everything
    this._$changeZIndex($('#main-wrapper'), '');
    $('html').removeClass('no-scroll');
  }

  createUnit(item, i, isActive) {
    return <SingleUnit data={item} key={i} isActive={isActive}
        dispatchReducer={this.props.dispatchReducer}
        comparedUnits={this.props.comparedUnits} />;
  }
}


Lightbox.propTypes = {
  data:               React.PropTypes.object.isRequired,
  heading:            React.PropTypes.string.isRequired,
  currClassification: React.PropTypes.string.isRequired,
  options:            React.PropTypes.object.isRequired,
  comparedUnits:      React.PropTypes.array.isRequired,
  dispatchReducer:    React.PropTypes.func.isRequired
};

export default Lightbox;
